import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-position"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "top-tip"
}
const _hoisted_5 = {
  key: 0,
  class: "drop-header"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 1,
  class: "drop-content-center"
}
const _hoisted_8 = {
  key: 2,
  class: "drop-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["easy-drop", [_ctx.customClasses, _ctx.dropdownType, { 'full-mobile': _ctx.isFullMobile, active: _ctx.dropdownActive, 'open-top': _ctx.openTop, 'accordion': _ctx.isAccordion }]]),
    "data-position": _ctx.position
  }, [
    _createElementVNode("button", {
      id: _ctx.buttonId,
      type: "button",
      class: _normalizeClass(["drop-open", [_ctx.customButtonClasses, { active: _ctx.dropdown }]]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.toggleDropdown(); _ctx.$emit('opened')}),
      ref: "dropdownButton"
    }, [
      (_ctx.dropdownType === 'select' && _ctx.useLabel)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.dropdownType === 'select')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.selectButtonValue), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, [
              _renderSlot(_ctx.$slots, "buttonText")
            ])
          ], 64))
        : _renderSlot(_ctx.$slots, "buttonText", { key: 1 })
    ], 10, _hoisted_2),
    (_ctx.hasTopTip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "drop-content",
      ref: "dropdownRef",
      style: _normalizeStyle(_ctx.position === 'right' ? { 'right': _ctx.positionValue + 'px' } : { 'left': _ctx.positionValue + 'px' })
    }, [
      (_ctx.$slots.contentHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.isFullMobile)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "back-btn",
                  title: _ctx.pageTexts['hotelPageNavigationButtonBack'],
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.toggleDropdown();})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "contentHeader")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.content)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "content")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.contentFooter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _renderSlot(_ctx.$slots, "contentFooter")
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 10, _hoisted_1))
}